<template>
  <div class="bg-white px-4 py-5 sm:p-4">
      <div class="text-xl font-bold" style="text-align: center;">
        Reintegros Embargo N° Proceso: <b style="color: #0e9f6e;">{{ data.numero_proceso }}</b>
      </div>
  </div>

  <div class="bg-white px-3 py-4 sm:p-4">
    <div class="flex flex-wrap justify-center sm:justify-between w-full gap-3 sm:gap-0 py-5 items-center">
      <div class="text-xl font-bold" >
        Valor pendiente por legalizar: <b style="color: #0e9f6e;"> {{ vueNumberFormat(data.pendiente_por_legalizar || 0, {})}}</b>
      </div>

      <button v-if="viewInterna == 'list'" type="button" @click="changeView('update')" class="flex items-center w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-3 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" style="white-space: nowrap;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Nuevo Reintegro
      </button>

      <button @click="viewInterna == 'list' ? handleButtonClick() : changeView('list');"
              class="px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
             stroke="currentColor" class="inline-block w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"/>
        </svg>
        <span class="ml-3">Volver</span>
      </button>
    </div>
    <slot></slot>
  </div>

  <div class="mt-6 overflow-x-auto" v-if="viewInterna == 'list'">
    <table class="w-full table-auto">
      <thead>
      <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
           Número comprobante
        </th>
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Fecha
        </th>
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Valor
        </th>
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Comprobante PDF
        </th>
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Opciones
        </th>
      </tr>
      </thead>
      <tbody class="text-sm font-normal text-gray-700 text-center">
        <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium" v-for="(dataReintegro, indexCollectionData) of collectionData" :key="indexCollectionData">
          <td class="px-4 py-4">
            {{ dataReintegro.numero_comprobante }}
          </td>
          <td class="px-4 py-4">
            {{ dataReintegro.fecha }}
          </td>
          <td class="px-4 py-4">
            {{ vueNumberFormat(dataReintegro.valor, {}) }}
          </td>
          <td class="px-4 py-4">
              <button v-if="dataReintegro.url_pdf" @click="descargarDocumentoSoporte(dataReintegro.url_pdf)"
                      class="px-4 py-2 text-white bg-blue-500 w-full rounded-md hover:bg-blue-600 focus:outline-none">
                <span>Descargar PDF</span>
              </button>
              <span v-else>-</span>
          </td>
          <td class="px-4 py-4">
              <button v-if="!dataReintegro.estado" @click="enableDisableState(dataReintegro,'activar')"
                      class="items-center px-2 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.5 12.75l6 6 9-13.5"/>
                </svg>
              </button>
              <button v-else @click="enableDisableState(dataReintegro,'desactivar')"
                      class="items-center px-2 py-2 text-white bg-red-500 rounded-md hover:bg-red-600 focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                </svg>
              </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div v-if="viewInterna == 'update'">
    <div class="bg-white px-4 py-5 sm:p-6" >
      <div class="grid grid-cols-6 gap-6" >
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="numero_comprobante" class="block text-sm font-medium text-gray-700">Número del comprobante <span style="color: red">(*)</span></label>
          <input type="text" id="numero_comprobante" v-model="numero_comprobante" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="fecha_reintegro" class="block text-sm font-medium text-gray-700">Fecha <span style="color: red">(*)</span></label>
          <input type="date" id="fecha_reintegro" v-model="fecha" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="valor_reintegro" class="block text-sm font-medium text-gray-700">Valor <span style="color: red">(*)</span></label>
          <input type="text" id="valor_reintegro" v-model="valor" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="archivo_reintegro" class="block text-sm font-medium text-gray-700">Comprobante en PDF</label>
          <input type="file" id="archivo_reintegro" accept=".pdf"
            @change="documentoSoporte=document.getElementById('archivo_reintegro').files.item(0);"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
          <p class="mt-1 text-xs text-gray-500">Tamaño máximo permitido del archivo adjunto: 10MB.</p>
        </div>
      </div>
    </div>

    <div id="btnUpdate" class="bg-gray-50 px-4 py-3 text-right sm:px-6">
      <button type="button" @click="customSaveData()" class="w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        Guardar
      </button>
    </div>
  </div>
</template>

<script>
import {saveUpdateData, enableDisableData} from "@/layouts/main";
import {ref, watch, nextTick} from "vue";
import Swal from "sweetalert2";
import { useAPIRest, swal, generateTextError, verifyHttpCode, separateNumberByCommaInput } from "@/common/constants";
import mime from "mime";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'ReintegrosEmbargoPersonaComponent',
  props: ['data', 'entity', 'authToken'],
  emits: ["updateValues", "watchList"],
  async setup(props, { emit }) {
    const viewInterna = ref('list');
    const numero_comprobante = ref('');
    const fecha = ref('');
    const valor = ref('');
    const documentoSoporte = ref('');

    const collectionData = ref([]);

    const changeView = (tipo_vista) => {
      viewInterna.value = tipo_vista
    }

    const customSaveData = async () =>  {
        try {

          const dataSave = {
            numero_comprobante: numero_comprobante.value,
            fecha: fecha.value,
            valor: (valor.value || '').replaceAll(',', ''),
          }

          const nameCompletoFields = {
            numero_comprobante: 'número del comprobante',
            fecha: 'fecha',
            valor: 'valor',
          }

          let error = '';
          for ( let key in nameCompletoFields){
            if(dataSave[key] == ''){
              error += `El campo ${ nameCompletoFields[key] } es obligatorio. <br>`;
            }
          }

          if (dataSave.valor !== '' && parseFloat(dataSave.valor) <= 0) {
            error += 'El valor del reintegro debe ser superior a 0. <br>';
          }

          if(error != ''){
            Swal.fire({
              title: error,
              icon: 'error',
              showCloseButton: true,
              focusConfirm: false,
            })
            return;
          }

          const newLoadData = new FormData();

          if (documentoSoporte.value) {
            const pesoMaximo = 10 * 1024 * 1024;
            if (documentoSoporte.value.size > pesoMaximo) {
              documentoSoporte.value = undefined;
              await swal.fire('¡El archivo excede el tamaño de 10MB maximo permitido!', '', 'error');
              return;
            }
            const uniqueFilename = `${uuidv4()}-${documentoSoporte.value.name}`;
            newLoadData.append('file', documentoSoporte.value, uniqueFilename);
          }

          const listApi = {
            create: process.env.VUE_APP_NEST_REINTEGROS_EMBARGOPERSONA_CREATE,
            list: process.env.VUE_APP_NEST_REINTEGROS_EMBARGOPERSONA_FINDONE,
          };

          newLoadData.append('id_embargo_persona', props.data.id);
          newLoadData.append('numero_comprobante', dataSave.numero_comprobante);
          newLoadData.append('fecha', dataSave.fecha);
          newLoadData.append('valor', dataSave.valor);

          await saveUpdateData({
            listApi,
            authToken: props.authToken,
            loadData: newLoadData,
            action: 'crear',
            entity: props.entity,
            view: 'crear',
            options: {
              save: {
                contentType: 'auto'
              },
              update: {
                contentType: 'auto'
              }
            }
          }, undefined, false, false, true);

          numero_comprobante.value = '';
          fecha.value = '';
          valor.value = '';
          documentoSoporte.value = undefined;
          viewInterna.value = 'list'

          listData();

        }catch (error) {
          Swal.fire({
              title: 'Error al guardar',
              icon: 'error',
              showCloseButton: true,
              focusConfirm: false,
            })
          console.error('Error al guardar:', error);
        }
    }

    const listData = async () => await useAPIRest(process.env.VUE_APP_NEST_REINTEGROS_EMBARGOPERSONA_FINDONE.replace(':id', props.data.id), 'GET', props.authToken, undefined, undefined, 'application/json')
      .then(res => {
          collectionData.value = res;
      });

    listData();

    const handleButtonClick = () => {
        emit('updateValues', { view: 'listar' });
        emit('watchList', { parametro: 'numero_comprobante' });
    }

    const enableDisableState = async (data, tipo)  => {
      const listApi = {
        updateState: process.env.VUE_APP_NEST_REINTEGROS_EMBARGOPERSONA_UPDATESTATE
      };

      await enableDisableData(props.entity, tipo, data, listApi['updateState'],  props.authToken)

      listData();
    }

    watch(() => valor.value, (newValor) => {
      nextTick(() => valor.value = separateNumberByCommaInput(newValor));
    })

    return {
      changeView,
      viewInterna,
      numero_comprobante,
      fecha,
      valor,
      customSaveData,
      collectionData,
      listData,
      handleButtonClick,
      documentoSoporte,
      document: document,
      enableDisableState
    }
  },
  methods: {
    async descargarDocumentoSoporte(fileName) {
        await useAPIRest(process.env.VUE_APP_NEST_REINTEGROS_EMBARGOPERSONA_OBTENERARCHIVO, 'GET', this.authToken, undefined, {
          'url': fileName
        }).then(async resJSON => {
          const {statusCode} = resJSON;
          delete resJSON.statusCode;
          const textoError = generateTextError(resJSON);
          if (verifyHttpCode(statusCode, 'success')) {
            const blob = await resJSON.blob();
            const newBlob = new Blob([blob], {type: mime.getType(fileName)});
            const url = window.URL.createObjectURL(newBlob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName.replace('src/assets/documentos_soporte_embargos/personas/reintegros/', ''));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else await swal.fire(textoError, '', 'error');
        });
      },
  },
}
</script>
